export enum GroupStatus {
  INACTIVE = "GROUP_STATUS_INACTIVE",
  ACTIVE = "GROUP_STATUS_ACTIVE"
}

export type GroupStatusLabelType = "All" | "Active" | "Inactive";

export type GroupPanelMode = "add" | "view" | "edit";

export type GroupStatusValueType =
  | ""
  | GroupStatus.ACTIVE
  | GroupStatus.INACTIVE;

export type SelectedStatusType = {
  label: GroupStatusLabelType;
  value: GroupStatusValueType;
};

export interface GetGroupsPayload {
  query?: string | null;
  status?: GroupStatus | null;
  sort_by?: string | null;
  order_by?: "asc" | "desc" | null;
  page?: number;
  per_page?: number;
}

export type GetUserGroupsData = {
  id: string;
  organization_id: string;
  name: string;
  description: string;
  status: GroupStatus.ACTIVE | GroupStatus.INACTIVE;
  module_count: number;
  user_count: number;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
};

export type GetUserGroupsPayload = {
  query?: string | null;
  status?: GroupStatus | null;
  sort_by?: string | null;
  order_by?: "asc" | "desc" | null;
  page?: number;
  per_page?: number;
};

export type GetUserGroupsResponse = {
  data: GetUserGroupsData[];
  meta: {
    pagination: {
      per_page: number;
      total: number;
      total_pages: number;
    };
  };
};

export type UserGroupPermissionPayload = {
  name: string;
  feature_id: string;
  selectedPermission: {
    label: string;
    value: string;
  } | null;
};

export interface EditGroupFormData {
  id: string;
  name: string | null;
  description: string;
  status: GroupStatus;
  group_permission: UserGroupPermissionPayload[];
}

export interface AddGroupFormData {
  name: string | null;
  description: string;
  status: GroupStatus;
  group_permission: UserGroupPermissionPayload[];
}

export type GroupFeature = {
  code: string;
  id: string;
  name: string;
  permission: string;
};

export type GetGroupByIdDetail = {
  id: string;
  name: string;
  organization_id: string;
  status: GroupStatus;
  description: string;
  features: GroupFeature[];
  users: {
    id: string;
    fullname: string;
  }[];
};

export type DeleteGroupPayload = { id: string; name: string };

export type GetUserGroupByIdPayload = {
  id: string;
};

export type GetUserGroupByIdResponse = {
  data: GetGroupByIdDetail;
};

export type UserGroupPermission = {
  permission: string;
  feature_id: string;
};

export type PutUserGroupPayload = {
  id: string;
  name: string | null;
  status: GroupStatus;
  description?: string;
  group_permission?: UserGroupPermission[];
};

export type PutUserGroupResponse = {
  id: string;
};

export type PostUserGroupPayload = {
  name: string | null;
  description: string;
  status: GroupStatus;
  group_permission?: UserGroupPermission[];
};

export type PostUserGroupResponse = {
  id: string;
};
